import React, {useState} from "react";

import Spinner from "@cirrus/legacy/app-components/spinner/spinner/index.jsx"

import { ContainerDiv, ViewerDiv } from "./parts"

import "./textLayer.css"

import {IPdfViewerProps} from "./props";
import {useViewer} from "./useViewer";
import {useStyles} from "./styles";
import {ErrorMessage} from "./error";

export const Viewer = (props: IPdfViewerProps) => {

    const styles = useStyles()
    const { containerRef, state, loadDocument } = useViewer(props)

    return (
        <ContainerDiv className={`pdf-viewer ${state.errorMessage ? styles.viewerError : ""}`} ref={containerRef}>
            {state.pending && <div className={styles.spinnerContainer}><Spinner /></div>}
            {state.errorMessage ? <ErrorMessage errorMessage={state.errorMessage} errorReport={state.errorReport} tryAgain={loadDocument} /> : null}
            <ViewerDiv />
        </ContainerDiv>
    )
}
